import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
//npm install vue-cookie --save
var VueCookie = require('vue-cookie');

export default new Vuex.Store({
  state: {
    actionMenu: '',
    pstQuery: '',
    unitQuery: '',
    user: {},
    supersPagins: '',
    userdata: VueCookie.get('userdata')
  },
  mutations: {
    saveUserData(state, userdata) {
      if (userdata) {
        state.userdata = userdata;
        //设置存储
        VueCookie.set('userdata', userdata, { expires: 90 });
      }else{
        state.userdata = "";
        //删除存储
        VueCookie.set('userdata', '', { expires: -1 });
        //console.log('delete')
      }
    },
    setActionId: function (state, selId) {
      state.actionMenu = selId
    },
    setPstQuery: function (state, parameter) {
      state.pstQuery = parameter
    },
    setUnitQuery: function (state, parameter) {
      state.unitQuery = parameter
    },
    setuser: function (state, user) {
      state.user = user
    },
    setSupersPagins: function (state, supersPagins) {
      state.supersPagins = supersPagins
    },
  },
  actions: {
  },
  modules: {
  }
})
